import React from 'react';

import { hexToRgba } from 'utils/colorUtils';

import classes from './ColorBadge.module.scss';

/**
 * A pill chip whose colour comes from the API rather than from a fixed set of
 * statuses — the tint is derived from the same hex as the label and the dot, so
 * any colour the backend sends renders consistently.
 */
const ColorBadge = ({ color, label, className }) => {
	if (!label) return null;

	const badgeColor = color || '#BB3A90';

	return (
		<span
			className={`${classes['color-badge']} ${className ? className : ''}`}
			style={{ backgroundColor: hexToRgba(badgeColor, 0.12), color: badgeColor }}>
			<span className={classes['dot']} style={{ backgroundColor: badgeColor }} />
			{label}
		</span>
	);
};

export default ColorBadge;
